<template>
    <div class="modal fade" id="survey-modal" tabindex="-1" ref="surveyModal">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">                
                <div class="modal-header">
                    <h5 class="modal-title">{{ surveyData.title || 'Survey' }}</h5>
                </div>
                
                <div class="modal-body">
                    <div v-if="isLoading" class="text-center p-5">
                        <div class="spinner-border text-success" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    
                    <!-- iframe for URL content -->
                    <div v-else-if="surveyData.type === EMBED_TYPE_URL && surveyData.content" class="survey-iframe-container">
                        <iframe 
                            :src="surveyData.content" 
                            class="responsive-iframe"
                            frameborder="0" 
                            allowfullscreen
                        ></iframe>
                    </div>
                    
                    <!-- Raw HTML content -->
                    <div v-else-if="surveyData.type === EMBED_TYPE_HTML && surveyData.content" 
                         class="survey-html-content" 
                         v-html="surveyData.content">
                    </div>
                    
                    <!-- No content message -->
                    <div v-else class="text-center p-5">
                        <p class="text-muted">No survey content available at this time.</p>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="suppressAndClose" v-if="surveyData.id">
                        Don't show for {{ surveyData.user_suppression_days }} days
                    </button>
                    <button type="button" class="btn btn-primary" @click="closeModal">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';
import api from "@/services/api";

const EMBED_TYPE_URL = 1;
const EMBED_TYPE_HTML = 2;

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        }
    },
    emits: ["close", "survey-set"],
    data() {
        return {
            EMBED_TYPE_URL: EMBED_TYPE_URL,
            EMBED_TYPE_HTML: EMBED_TYPE_HTML,
            modal: null,
            surveyData: {
                id: null,
                type: null, 
                content: null,
                title: null,
                show_to_user: false,
            },
            isLoading: false,
            showModal: false,
            userId: null
        }
    },
    mounted() {
        this.surveyModalInstance = new Modal(this.$refs.surveyModal, {});

        this.$watch("show", (newVal) => {
            if (newVal) {
                this.surveyModalInstance.show()
            } else {
                this.surveyModalInstance.hide()
            }
        }, { immediate: true });

        this.$refs.surveyModal.addEventListener("hidden.bs.modal", () => {
            if (this.show) {
                this.$emit("close")
            }
        });

        this.fetchLatestSurvey();
    },
    methods: {
        closeModal() {
            this.modalInstance.hide();
            this.$emit("close");
        },
        fetchLatestSurvey() {
            if (!this.$store.state.user) {
                console.log('User not signed in, skipping survey fetch');
                return;
            }

            this.isLoading = true;
            
            api.get('/api/v1/survey/latest')
                .then((response) => {

                    console.log('Survey response:', response.data);
                    if (response.data && response.data.id) {
                        if (!response.data.is_active || !response.data.show_to_user) {
                            console.log('Survey not active or not active for this user');
                            return;
                        }
                        
                        this.surveyData = {
                            id: response.data.id,
                            type: response.data.embed_type,
                            content: response.data.source,
                            title: response.data.name || 'Survey',
                            user_suppression_days: response.data.user_suppression_days || 7,
                            is_active: response.data.is_active,
                            show_to_user: response.data.show_to_user,
                            source_origin: response.data.source_origin,
                        };
                    } else {
                        console.log('No surveys');
                        return;
                    }
                })
                .catch((error) => {
                    console.error('Error fetching survey:', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        suppressAndClose() {
            if (this.surveyData.id && this.$store.state.user) {                
                api.post('/api/v1/survey/suppress', {
                    survey_id: this.surveyData.id,
                })
                .catch((error) => {
                    console.error('Error suppressing survey:', error);
                });
            }
            
            this.closeModal();
        },
    }
}
</script>

<style scoped lang="scss">
    .modal-content {
        margin-bottom: 100px;

        .modal-body {
            padding: 0;        
        }
    }

     .responsive-iframe {
        height: 250px;
        width: 100%;
    }    

    @media (min-height: 600px) and (max-height: 799px) {
        .responsive-iframe
        {
        height: 350px;
        }
    }

    @media (min-height: 800px) and (max-height: 999px) {
        .responsive-iframe
        {
        height: 550px;
        }
    }

    @media (min-height: 1000px) and (max-height: 1199px) {
        .responsive-iframe
        {
        height: 750px;
        }
    }

    @media (min-height: 1200px) {
        .responsive-iframe
        {
        height: 950px;
        }
    }
</style>